import { Outlet } from 'react-router-dom';
import { useIsLandscape } from '../responsiveDesign/responsiveDesign';

/**
 * Layout for detail pages (without TopBar)
 * Used for routes like /profile, /settings, /videos/:id, /users/:id
 */
export const DetailsRouteContainer = () => {
  const isLandscape = useIsLandscape();

  return (
    <main>
      {/* Full width on portrait, centered with max-width on landscape */}
      <div className={isLandscape
        ? "sm:mx-auto sm:max-w-[75%] md:max-w-[75%] lg:max-w-[75%] xl:max-w-[75%] 2xl:max-w-[75%]"
        : "w-full"}
      >
        {/* Content without TopBar */}
        <Outlet />
      </div>
    </main>
  );
};
